import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AuthorizationGuard } from '@shared/authentication/authentication.guard';
import { HOME_PAGE } from '@shared/constants/routing-constants';

const routes: Routes = [
  {
    path: HOME_PAGE,
    canActivate: [AuthorizationGuard],
    loadComponent: () =>
      import('./pages/dashboard/kfm-dashboard.component').then(
        (m) => m.KfmDashboardComponent,
      ),
  },
];

export const homeRoutingModule: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(routes);
